export default __webpack_public_path__ + "static/media/novostroyHeader.ad31963b.svg";